module.exports = __webpack_public_path__ + "static/media/12.f76f46ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/12.svg
// module id = 124
// module chunks = 0